<template>
  <div>
    <div class="box bg-[#2C7952]/40">
      <div class="flex items-start">
        <span>{{ $t('Activities.Agentcenter.Components.ResumoContent.YesterdayIncome') }}</span>
      </div>
      <span class="text-white font-[500]">
        {{ formatter().format(overview.myIncome || 0) }}
      </span>
    </div>
    <div class="box bg-[#2C7952]/20">
      <div class="flex items-start">
        <span>{{ $t('Activities.Agentcenter.Components.ResumoContent.SubordinatedDeposits') }}</span>
      </div>
      <span class="text-white">
        {{ formatter().format(overview.subDeposit || 0) }}
      </span>
    </div>
    <div class="box bg-[#2C7952]/40">
      <div class="flex items-start">
        <span>{{ $t('Activities.Agentcenter.Components.ResumoContent.SubordinatesTakeout') }}</span>
      </div>
      <span class="text-white">
        {{ formatter().format(overview.subWithdrawal || 0) }}
      </span>
    </div>
    <div class="box bg-[#2C7952]/20">
      <div class="flex items-start">
        <span>{{ $t('Activities.Agentcenter.Components.ResumoContent.StationedSubordinates') }}</span>
      </div>
      <span class="text-white">
        {{ formatter().format(overview.subBet || 0) }}
      </span>
    </div>
    <div class="box bg-[#2C7952]/40">
      <div class="flex items-start">
        <span>{{ $t('Activities.Agentcenter.Components.ResumoContent.SubordinatedProfit') }}</span>
      </div>
      <span class="font-[500] text-white">
        {{ formatter().format(overview.subWinLoss || 0) }}
      </span>
    </div>
  </div>
</template>

<script setup lang="ts">
import { formatter } from "@/utils";
import dayjs from "dayjs";
import { getAgentOverview } from "@/api/agent";
const overview = ref<any>({});
const getAgentOverviewData = async () => {
  try {
    const res = await getAgentOverview({
      startTime: dayjs().subtract(1, "day").startOf("day").valueOf(),
      endTime: dayjs().subtract(1, "day").endOf("day").valueOf(),
      agentLevel: "All",
    });
    if (res.code == 1) {
      overview.value = res.data.data[0];
    }
  } catch (error) {
    console.log(error);
  }
};

onMounted(() => {
  getAgentOverviewData();
});
</script>

<style scoped lang="scss">
.box {
  @apply flex items-center justify-between px-[10px] py-2.5 mt-px text-[15px];
}
</style>
